module.exports = __webpack_public_path__ + "static/img/preview-05.88f9a63a.webp";